<template>
  <div id="main" class="flex flex-col items-center px-6 bg-gray-100 fle sm:p-0">
    <h1 class="text-2xl">Page Not Found</h1>
  </div>
</template>
